<template>
  <div class="app-main"><router-view /></div>
</template>

<script>
export default {
  name: "app-main",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  margin-top: $navigation-height;
}
</style>
